import Header from '../components/Header'
import Meta from '../components/Meta'
import React, { useState,useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
const About = () => {
	useEffect(() => {
		// 👇 add class to body element
		document.body.classList.add('bg-black');


		return () => {
			// 👇️ removing classes from body element
			// when the component unmounts
			document.body.classList.remove('bg-black');
		}
	}, []);
  const [showOk, setShowOk] = useState(false);
	const [showError, setShowError] = useState(false);

  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

	const handleCloseOk = () => setShowOk(false);
  const handleShowOk = () => setShowOk(true);


	const handleCloseError = () => setShowError(false);
  const handleShowError = () => setShowError(true);

	let array = [
		376200,
	376201,
	376202,
	376203,
	376204,
	376205,
	376206,
	376207,
	376208,
	376209,
	376210,
	376211,
	376212,
	376213,
	376214,
	376215,
	376216,
	376217,
	376218,
	376219,
	379855,
	379873,
	379874,
	379875,
	377359,
	377360,
	377361,
	377381,
	];
// str= str.replace("\t","")
// 	let array = str.split("\n")
// 	console.log('array',array)

const doSomething = function (e) {

	e.preventDefault();
}

	const	handleCheck = () => {
		console.log('email',email)
		if(array.includes(parseInt(email))){
			//alert("ok");
			setShow(false)
			setShowOk(true)
		}
		else {
			setShow(false)
			setShowError(true)
		}
	}


const handleError = () => {
	setShow(false)
	setShowError(false)
}


  return (
    <div className="american">
<>
  <div>
    <p className="c0">
      <span className="c10" />
    </p>
  </div>
  <p className="c5">
    <span className="c6">MANDALA PRESENTS: F1 EXTRAVAGANZA</span>
  </p>
  <p className="c4">
    <span
      style={{
        overflow: "hidden",
        display: "inline-block",
        margin: "0.00px 0.00px",
        border: "0.00px solid #000000",
        transform: "rotate(0.00rad) translateZ(0px)",
        WebkitTransform: "rotate(0.00rad) translateZ(0px)",
        width: "601.70px",
        height: "282.67px"
      }}
    >
      <img
        alt=""
        src="/extra/image5.jpg"
        style={{
          width: "601.70px",
          height: "282.67px",
          marginLeft: "0.00px",
          marginTop: "0.00px",
          transform: "rotate(0.00rad) translateZ(0px)",
          WebkitTransform: "rotate(0.00rad) translateZ(0px)"
        }}
        title=""
      />
    </span>
  </p>
  <p className="c3">
    <span className="c1">
      The world's most anticipated night race is back after a two-year hiatus
      this year. Mandala x Marina Bay Sands present an inaugural F1 Weekender
      extravaganza of breathtaking views of the Qualifying race and exciting
      music over the Singapore Formula 1 Grand Prix weekend.
    </span>
  </p>
  <p className="c3">
    <span className="c1">
      Exclusively for American Express® Singapore, eligible Card Members and
      their guests are invited to an evening in the skies 56 stories above the
      Marina Bay circuit, as the iconic apex of the Marina Bay Sands Observation
      Deck is transformed into an exclusive Members-and-guests only hospitality
      lounge on Saturday, 1 October 2022. Enjoy access to uninterrupted views of
      the Marina Bay circuit and catch all the race action with live screening
      at the lounge, accompanied with free flow house wine, spirits and beers.
      Light canapes are served before 8.30PM.
    </span>
  </p>
  <p className="c4">
    <span
      style={{
        overflow: "hidden",
        display: "inline-block",
        margin: "0.00px 0.00px",
        border: "0.00px solid #000000",
        transform: "rotate(0.00rad) translateZ(0px)",
        WebkitTransform: "rotate(0.00rad) translateZ(0px)",
        width: "601.70px",
        height: "601.33px"
      }}
    >
      <img
        alt=""
        src="/extra/image1.jpg"
        style={{
          width: "601.70px",
          height: "601.33px",
          marginLeft: "0.00px",
          marginTop: "0.00px",
          transform: "rotate(0.00rad) translateZ(0px)",
          WebkitTransform: "rotate(0.00rad) translateZ(0px)"
        }}
        title=""
      />
    </span>
  </p>
  <p className="c3">
    <span className="c1">
      The party continues as you race into the night with full 3-day access to
      the inaugural Mandala Weekender Music and Arts Festival, featuring a
      stellar line-up of international and local artists and DJs. Catch
      headliners Kelis, Rae Sremmurd, Armand van Helden, Louis Vega with Anane,
      and Rudimental as the Mandala Weekender Music and Arts Festival is set to
      bring you an incredible F1 weekend experience.
    </span>
  </p>
  <p className="c4">

    <span
      style={{
        overflow: "hidden",
        display: "inline-block",
        margin: "0.00px 0.00px",
        border: "0.00px solid #000000",
        transform: "rotate(0.00rad) translateZ(0px)",
        WebkitTransform: "rotate(0.00rad) translateZ(0px)",
        width: "253.15px",
        height: "87.27px"
      }}
			onClick={handleShow}
    >
      <img
        alt=""
        src="/extra/image6.png"
        style={{
          width: "253.15px",
          height: "87.27px",
          marginLeft: "0.00px",
          marginTop: "0.00px",
          transform: "rotate(0.00rad) translateZ(0px)",
          WebkitTransform: "rotate(0.00rad) translateZ(0px)"
        }}
        title=""
      />
    </span>
  </p>

</>

      <Modal show={show} onHide={handleClose}>

        <Modal.Body>
				<p className="c4">
    <span className="c2">
      &nbsp;VERIFY YOU'RE AN ELIGIBLE<br />
      AMERICAN EXPRESS CARD HOLDER.
      <br />
      ENTER THE FIRST 6 DIGITS OF YOUR CARD.
    </span>
  </p>

	<Form onSubmit={doSomething}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label></Form.Label>
              <Form.Control
                type="card_6"
                placeholder=""
                autoFocus
								onChange={(e) => {
									setEmail(e.target.value);
									console.log({ email });
								}}
								style={{width:'30%',margin: '0 auto',textAlign:'center'}}
              />
            </Form.Group>

          </Form>
					<p className="c4 c9">
    <span className="c2" />
  </p>
  <p className="c4">
    <span
		onClick={handleCheck}
      style={{
        overflow: "hidden",
        display: "inline-block",
        margin: "0.00px 0.00px",
        border: "0.00px solid #000000",
        transform: "rotate(0.00rad) translateZ(0px)",
        WebkitTransform: "rotate(0.00rad) translateZ(0px)",
        width: "176.93px",
        height: "61.50px"
      }}
    >
      <img
        alt=""
        src="/extra/image3.png"
        style={{
          width: "176.93px",
          height: "61.50px",
          marginLeft: "0.00px",
          marginTop: "0.00px",
          transform: "rotate(0.00rad) translateZ(0px)",
          WebkitTransform: "rotate(0.00rad) translateZ(0px)"
        }}

        title=""
      />
    </span>
  </p>
				</Modal.Body>

      </Modal>



			<Modal show={showOk} onHide={handleCloseOk}>

<Modal.Body>
<p className="c4">
    <span className="c2">
      &nbsp;THANK YOU
      <br />
      <br />
      HERE'S YOUR ONE-TIME LINK TO
      <br />
      PURCHASE YOUR TICKETS.
    </span>
  </p>
  <p className="c4">
    <a href="http://sevn.ly/xrlnwMjw"
      style={{
        overflow: "hidden",
        display: "inline-block",
        margin: "0.00px 0.00px",
        border: "0.00px solid #000000",
        transform: "rotate(0.00rad) translateZ(0px)",
        WebkitTransform: "rotate(0.00rad) translateZ(0px)",
        width: "376.65px",
        height: "63.08px"
      }}
    >
      <img
        alt=""
        src="/extra/image4.png"
        style={{
          width: "376.65px",
          height: "63.08px",
          marginLeft: "0.00px",
          marginTop: "0.00px",
          transform: "rotate(0.00rad) translateZ(0px)",
          WebkitTransform: "rotate(0.00rad) translateZ(0px)"
        }}
        title=""
      />
    </a>
  </p>





</Modal.Body>

</Modal>





<Modal show={showError} onHide={handleCloseError}>

<Modal.Body>
<p className="c4">
    <span className="c2">
      &nbsp;SORRY <br />
      <br />
      ONLY ELIGIBLE AMERICAN EXPRESS
      <br />
      CARDS ACCEPTED
    </span>
  </p>
  <p className="c4">
    <span
      style={{
        overflow: "hidden",
        display: "inline-block",
        margin: "0.00px 0.00px",
        border: "0.00px solid #000000",
        transform: "rotate(0.00rad) translateZ(0px)",
        WebkitTransform: "rotate(0.00rad) translateZ(0px)",
        width: "231.65px",
        height: "65.47px"
      }}
			onClick={handleError}
    >
      <img
        alt=""
        src="/extra/image2.png"
        style={{
          width: "231.65px",
          height: "65.47px",
          marginLeft: "0.00px",
          marginTop: "0.00px",
          transform: "rotate(0.00rad) translateZ(0px)",
          WebkitTransform: "rotate(0.00rad) translateZ(0px)"
        }}
        title=""
      />
    </span>
  </p>





</Modal.Body>

</Modal>


		</div>
  )
}

export default About
